import { motion } from "framer-motion";
import heroImg from "../assets/heroImg.png"; // Your hero image
import SubHero from "./SubHero";
import Services from "./Services";

export default function Hero() {
  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-r from-white via-blue-50 to-white py-16">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-12">

        {/* LEFT CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Badge */}
          <div className="inline-flex items-center rounded-full bg-blue-100 px-5 py-2 text-[#075DA8] font-medium text-sm mb-6">
            We Build Digital Careers
          </div>

          {/* Heading */}
          <h1 className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
            Transform Your
            <br />
            <span className="text-[#075DA8]">
              IT Career
            </span>
            <br />
            With Expert Training
          </h1>

          {/* Description */}
          <p className="mt-8 text-gray-600 text-lg leading-8 max-w-xl">
            MSM Technologies delivers practical, industry-focused IT training
            designed by experienced professionals. Learn real-world skills,
            build confidence, and accelerate your career with expert guidance.
          </p>

          {/* Buttons */}
          <div className="flex flex-wrap gap-4 mt-10">
            <button className="bg-[#075DA8] text-white px-8 py-4 rounded-xl font-semibold hover:bg-[#064b88] transition">
              Explore Courses
            </button>

            <button className="border-2 border-[#075DA8] text-[#075DA8] px-8 py-4 rounded-xl font-semibold hover:bg-blue-50 transition">
              View Programs
            </button>
          </div>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          className="relative flex justify-center"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Main Image */}
          <img
            src={heroImg}
            alt="Hero"
            className="w-full max-w-3xl rounded-3xl"
          />
        </motion.div>

      </div>
    </section>
    <SubHero/>

    <Services/>


    </>
  );
}